import { LibraryAsset } from "./library-asset";
import { LibraryExerciseAnswer } from "./LibraryExerciseAnswer";

export class LibraryAssetResult {
    public id:string;
	public assignmentItemId:number;
	public asset:LibraryAsset;
	public answers: LibraryExerciseAnswer[];
	public journal:string;
	
	constructor() {
        this.answers = [];
	}
}


// WEBPACK FOOTER //
// ./src/app/library-assets/models/library-asset-result.ts